import loadable from '@loadable/component';

export const ComparisonNotificationContainerLoadable = loadable(() => import('./ComparisonNotificationContainer'), {
  resolveComponent: module => module.ComparisonNotificationContainer,
  ssr: false,
});
